
import httpRequest from './../infrastructure/httphelper'

class menuServices {
    constructor() {}

    getUserMenu() {
        return httpRequest({
            //refactor code 

        }).then(function(resp){
           //
        });
    }
}  
let instance = new menuServices();
export default instance;